export default __webpack_public_path__ + "img/fa20927dfd068a6fbfb86380a6958656.svg";